/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Charts_Legend_DoneInputs */

const en_us2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

const es_419_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const pt_pt2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

const fr_fr2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fait`)
};

const de_de2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt`)
};

const it_it2_ui_charts_legend_done = /** @type {(inputs: Ui_Charts_Legend_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Ui_Charts_Legend_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_legend_done = /** @type {((inputs?: Ui_Charts_Legend_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Legend_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_legend_done(inputs)
	if (locale === "es-419") return es_419_ui_charts_legend_done(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_legend_done(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_legend_done(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_legend_done(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_legend_done(inputs)
	return en_us2_ui_charts_legend_done(inputs)
});
export { ui_charts_legend_done as "ui-charts.legend_done" }